import {subMonths} from "date-fns";
<template>
  <gj-tooltip
      :disabled="isMeaningless(tooltip)"
      :content="tooltip">
    <el-date-picker v-if="type ==='monthrange'"
        v-bind="$attrs"
        v-on="$listeners"
        :size="mapSize"
        type="month"
        :unlink-panels="true"
        :placeholder="placeholder"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        :picker-options="mapPickerOptions"
        :clearable="clearable"
        :style="{width: mapWidth}"
        :class="{'gj-date-picker--font14': font14}">
    </el-date-picker>
    <div>
      <el-date-picker v-if="type !=='monthrange'"
                      v-bind="$attrs"
                      v-on="$listeners"
                      :size="mapSize"
                      :type="type"
                      :unlink-panels="true"
                      :placeholder="placeholder"
                      start-placeholder="开始日期"
                      end-placeholder="结束日期"
                      :picker-options="mapPickerOptions"
                      :clearable="clearable"
                      :style="{width: mapWidth}"
                      :class="{'gj-date-picker--font14': font14}">
      </el-date-picker>
    </div>

  </gj-tooltip>
</template>

<script>

import {isMeaningful, isMeaningless} from "@/utils/common";
import {subMonths} from "date-fns";
import {font14MixIn, isMeaninglessMixin, tooltipMixin} from "@/minxins";
import {DATE_SHORTCUTS} from "@/utils/const";

const sizeMap = {
  'default': 'small',
};

export default {
  name: "gj-date-picker-active",
  mixins: [font14MixIn, tooltipMixin, isMeaninglessMixin],
  props: {
    width: {
      type: String
    },
    size: {
      type: String,
      default: 'default',
      validator: function (value) {
        return ['default'].indexOf(value) !== -1
      }
    },
    type: {
      type: String,
      default: 'date'
    },
    clearable: {
      type: Boolean,
      default: true
    },
    // type = monthrange 填需要控制的月数，其他的为天数
    maxDayLength: {
      type: Number,
      default: null
    },
    shortcut: {
      type: Boolean,
      default: true
    },
    placeholder: {
      type: String,
      default: '请选择'
    },
    shortcuts: {
      type: Array,
      default: () => ['今天', '昨天', '近7天', '近30天', '本月', '上月', '本年至今'],
    },
    disabledDate: {
      default: null
    }
  },
  data() {
    return {
      pickerOptions: {},
      shortcutsList: [
        {
          text: DATE_SHORTCUTS.today.text,
          onClick(picker) {
            picker.$emit('pick', DATE_SHORTCUTS.today.date);
          }
        },
        {
          text: DATE_SHORTCUTS.yesterday.text,
          onClick(picker) {
            picker.$emit('pick', DATE_SHORTCUTS.yesterday.date);
          }
        },
        {
          text: DATE_SHORTCUTS.last7Day.text,
          onClick(picker) {
            picker.$emit('pick', DATE_SHORTCUTS.last7Day.date);
          }
        },
        {
          text: DATE_SHORTCUTS.last14Day.text,
          onClick(picker) {
            picker.$emit('pick', DATE_SHORTCUTS.last14Day.date);
          }
        },
        {
          text: DATE_SHORTCUTS.last30Day.text,
          onClick(picker) {
            picker.$emit('pick', DATE_SHORTCUTS.last30Day.date);
          }
        },
        {
          text: DATE_SHORTCUTS.last60Day.text,
          onClick(picker) {
            picker.$emit('pick', DATE_SHORTCUTS.last60Day.date);
          }
        },
        {
          text: DATE_SHORTCUTS.last90Day.text,
          onClick(picker) {
            picker.$emit('pick', DATE_SHORTCUTS.last90Day.date);
          }
        },
        {
          text: DATE_SHORTCUTS.currentMonth.text,
          onClick(picker) {
            picker.$emit('pick', DATE_SHORTCUTS.currentMonth.date);
          }
        },
        {
          text: DATE_SHORTCUTS.lastMonth.text,
          onClick(picker) {
            picker.$emit('pick', DATE_SHORTCUTS.lastMonth.date);
          }
        },
        {
          text: DATE_SHORTCUTS.yearToToday.text,
          onClick(picker) {
            picker.$emit('pick', DATE_SHORTCUTS.yearToToday.date);
          }
        }
      ]
    }
  },
  created() {
    // const vm = this;
    // if (['datetimerange', 'daterange', 'monthrange'].includes(this.type)) {
    //   this.pickerOptions = {
    //     disabledDate(time) {
    //       if (isMeaningless(vm.maxDayLength)) {
    //         return false;
    //       }
    //       if ("monthrange" == vm.type) {
    //         // subMonths 偏移月份
    //         return time.getTime() > subMonths(vm.timeOptionRange, vm.maxDayLength * -1) ||
    //             time.getTime() < subMonths(vm.timeOptionRange, vm.maxDayLength)
    //       } else {
    //         let timeOptionRange = vm.timeOptionRange;
    //         let secondNum = vm.maxDayLength * 24 * 60 * 60 * 1000;
    //         if (timeOptionRange) {
    //           return time.getTime() > timeOptionRange.getTime() + secondNum || time.getTime() < timeOptionRange.getTime() - secondNum;
    //         }
    //       }
    //     },
    //     onPick(time) {
    //       //当第一时间选中才设置禁用
    //       if (time.minDate && !time.maxDate) {
    //         vm.timeOptionRange = time.minDate;
    //       }
    //       if (time.maxDate) {
    //         vm.timeOptionRange = null;
    //       }
    //     }
    //   };
    //   if (this.shortcut) {
    //     if(this.type === 'monthrange'){ //月度仅有 本月，上月
    //       this.pickerOptions.shortcuts = this.shortcutsList.filter(e => this.shortcuts.includes(e.text))
    //     } else {
    //       this.pickerOptions.shortcuts = this.shortcutsList.filter(e => this.shortcuts.includes(e.text))
    //     }
    //   }
    // } else if (isMeaningful(this.disabledDate)) {
    //   this.pickerOptions = {
    //     disabledDate: this.disabledDate
    //   };
    // }
  },
  computed: {
    mapSize() {
      return sizeMap[this.size];
    },
    mapWidth() {
      if (isMeaningful(this.width)) {
        return this.width;
      } else if (isMeaningful(this.type) && this.type.includes('range')) {
        return '210px';
      } else {
        return '127px';
      }
    },
    mapPickerOptions(){
      const vm = this;
      let pickerOptions = {};
      if (['datetimerange', 'daterange', 'monthrange'].includes(this.type)) {
        pickerOptions.disabledDate = function (time){
          if (isMeaningless(vm.maxDayLength)) {
            return false;
          }
          if ("monthrange" == vm.type) {
            // subMonths 偏移月份
            return time.getTime() > subMonths(vm.timeOptionRange, vm.maxDayLength * -1) ||
                time.getTime() < subMonths(vm.timeOptionRange, vm.maxDayLength)
          } else {
            let timeOptionRange = vm.timeOptionRange;
            let secondNum = vm.maxDayLength * 24 * 60 * 60 * 1000;
            if (timeOptionRange) {
              return time.getTime() > timeOptionRange.getTime() + secondNum || time.getTime() < timeOptionRange.getTime() - secondNum;
            }
          }
        }
        pickerOptions.onPick = function (time){
          //当第一时间选中才设置禁用
          if (time.minDate && !time.maxDate) {
            vm.timeOptionRange = time.minDate;
          }
          if (time.maxDate) {
            vm.timeOptionRange = null;
          }
        }
        if (this.shortcut) {
          pickerOptions.shortcuts = this.shortcutsList.filter(e => this.shortcuts.includes(e.text))
        }
      } else {
        pickerOptions.disabledDate = vm.disabledDate;
      }
      return pickerOptions;
    }
  },
  methods:{
    /** 生成配置日期列表 shortcuts 为英文字符 */
    createShortcutsList(shortcuts=[]){
     this.shortcutsList = shortcuts.map(v=>{
        return{
          text:DATE_SHORTCUTS[v].text,
          onClick(picker){
            picker.$emit('pick', DATE_SHORTCUTS[v].date);
          }
        }
      })
    }
  }
}
</script>

<style scoped>
.gj-date-picker--font14 /deep/ .el-input__inner {
  font-size: 14px !important;
}
</style>
